import { makeStyles } from 'makeStyles';
import { DISABLED_AND_BORDERS } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  tablePaperTitle: {
    marginBottom: theme.spacing(2),
  },
  tablePaperSubtitle: {
    color: theme.palette.grey['50'],
    marginBottom: theme.spacing(2),
  },
  tableFont: {
    fontSize: 13,
  },
  headerStyle: {
    fontWeight: 'bold',
    color: 'blue',
  },
  headerFontStyle: {
    color: theme.typography.body1.color,
    fontSize: 13,
    fontWeight: 600,
  },
  divider: {
    height: '20px',
    width: '100%',
  },
  RTableConfig: {
    boxShadow: 'none',
    '& > div': {
      minWidth: 1000,
    },
  },
  drawsChips: {
    padding: `${theme.spacing(2)} 0!important`,
    width: '200px',
  },
  selectedRow: {
    background: theme.palette.grey['400'],
  },
  // EventParticipants
  paper: {
    position: 'relative',
  },
  EPTableConfig: {
    boxShadow: 'none',
    '& > div': {
      minWidth: 1000,
    },
    '& .MuiTableCell-head': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderBottom: `2px solid rgba(224, 224, 224, 1)`,
    },
    '& .MuiTableCell-root': {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5),
      '& .MuiButtonBase-root:not(.MuiCheckbox-root)': {
        width: 'auto',
        padding: 0,
        '& .MuiSvgIcon-root': {
          fontSize: 18,
        },
      },
    },
    '& .MuiTableRow-hover:hover': {
      cursor: 'pointer',
    },
  },
  EPCellConfig: {
    padding: 0,
  },
  EPTableIndexCell: {
    borderBottom: 'none',
    width: '30px',
  },
  EPFullNameCell: {
    minWidth: '100px',
  },
  EPScaleCell: {
    maxWidth: '20px',
  },
  EPGenderCell: {
    maxWidth: '30px',
  },
  EPTableCellNoWrap: {
    whiteSpace: 'nowrap',
    width: '5%',
  },
  inputMargin: {
    marginRight: '1em',
  },
  iconMargin: {
    marginRight: '.5em',
  },
  buttonIcon: {
    height: '16px',
    marginRight: theme.spacing(1),
    stroke: theme.palette.grey['50'],
    width: 'auto',
    '&:svg': {
      width: 16,
      height: 16,
    },
  },
  buttonIconRight: {
    marginRight: 0,
    marginLeft: theme.spacing(1),
  },
  downIcon: {
    fontWeight: 'normal',
    '&:hover': {
      cursor: 'pointer',
      borderRadius: 4,
      backgroundColor: '#eaecf2',
    },
  },
  tickIcon: {
    alignSelf: 'center',
    height: 16,
  },
  popoverItem: {
    padding: '2px 18px',
    minWidth: 33,
    '& svg': {
      height: 16,
      width: 16,
      '& path': {
        height: 16,
        width: 16,
      },
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  eventPopoverItem: {
    paddingRight: 0,
  },
  listWithIcon: {
    '& svg': {
      width: '16px',
      height: '16px',
      marginRight: 4,
    },
    '& .MuiListItem-root': {
      lineHeight: '1.5',
    },
  },
  listWithTickIcon: {
    '& svg': {
      width: '16px',
      height: '16px',
    },
    '& .MuiListItem-root': {
      lineHeight: '1.5',
      padding: '5px 18px',
    },
    '& .MuiGrid-spacing-xs-1 > .MuiGrid-item:nth-of-type(2)': {
      paddingLeft: 0,
      marginLeft: '-2px',
    },
  },
  iconCenter: {
    display: 'flex',
    alignSelf: 'center',
  },
  // Resources table
  resourcesTableCellConfig: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  dragCellTitle: {
    padding: 15,
    width: '10px',
  },
  dragCellIconSVG: {
    display: 'block',
    margin: 'auto',
  },
  male: {
    '& div': {
      color: '#3333cc',
    },
  },
  female: {
    '& div': {
      color: '#ff3399',
    },
  },
  tableConfig: {
    boxShadow: 'none',
  },
  signInCell: {
    minWidth: 150,
    width: '15%',
  },
  signInContainer: {
    cursor: 'pointer',
  },
  signInButton: {
    gap: '10px',
    padding: '4px 5px',
  },
  signIn: {
    border: `1px solid ${DISABLED_AND_BORDERS}`,
    borderRadius: '50%',
    height: '24px',
    width: '24px',
  },
  signInFilled: {
    height: '24px',
    width: '24px',
  },
  playerContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  winner: {
    color: '#118174',
    marginRight: 6,
  },
  tableDoubles: {
    display: 'flex',
  },
  tableDoublesWinner: {
    display: 'block',
    color: '#118174',
    marginRight: 6,
  },
  columnsButtonWrapper: {
    marginTop: 20,
  },
  pointer: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  csvLink: {
    textDecoration: 'none',
  },
  loaderGrey: {
    color: theme.palette.grey[50],
  },
  actions: {
    textAlign: 'center',
    verticalAlign: 'middle',
  },
  playersWarning: {
    margin: '16px 0px -40px 16px',
  },
}));
